<template>
    <div class="intro-chapter-base">
        <div class="container">
            <a-row class="inner">
                <a-col :lg="12" :xs="0">
                    <div class="ipad-base">
                        <div class="ipad">
                            <div class="screen">
                                <img src="/assets/introtower.png">
                            </div>
                        </div>
                    </div>
                </a-col>
                <a-col :lg="12" class="intro-title">
                    <div class="content text-center">
                        <h1>专业的魔塔游戏平台</h1>
                        <p>H5魔塔广场是专注于魔塔类游戏的平台，在这里，探索魔塔的更多可能性</p>
                        <a-button type="primary" class="sign-up-btn">
                            <a href="/user/register.html">注册账号 &nbsp;<a-icon type="right" /></a>
                        </a-button>
                    </div>
                </a-col>
            </a-row>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="less">
.intro-chapter-base,
.intro-chapter-base * {
  -webkit-transition: 0.4s all;
  -o-transition: 0.4s all;
  transition: 0.4s all;
}
.intro-chapter-base {
    min-height: 400px;
    
    .intro-title {
        margin: auto;
    }
    .container {
        padding-left: 50px;
        padding-right: 50px;
        .inner {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
        }
        .content {
            margin-top: 100px;
            color: white;
            @media (max-width: 767px) {
                margin-top: 60px !important;
            }
            p {
                margin-top: 40px;
            }
            .sign-up-btn {
                margin-top: 30px;
            }
        }
    }
    @media (min-width: 768px) {
        margin-top: 100px;
    }
    @media (max-width: 767px) {
        min-height: 300px;
        padding-top: 20px;
        .container .content {
            margin-top: 80px;
        }
    }
}
.ipad-base {
    margin-top: 100px;
    // @media (max-width: 991px) {
    //     display: none;
    // }
    .ipad {
        position: relative;
        -webkit-transform: rotate(-8deg);
                transform: rotate(-8deg);
        -webkit-transform-origin: 50% 50%;
                transform-origin: 50% 50%;
        width: 414px;
        height: 284px;
        border-radius: 30px;
        background: #fff;
        -webkit-box-shadow: inset 0 4px 7px 1px #ffffff, inset 0 -5px 20px rgba(173, 186, 204, 0.25), 0 2px 6px rgba(0, 21, 64, 0.14), 0 10px 20px rgba(0, 21, 64, 0.05);
                box-shadow: inset 0 4px 7px 1px #ffffff, inset 0 -5px 20px rgba(173, 186, 204, 0.25), 0 2px 6px rgba(0, 21, 64, 0.14), 0 10px 20px rgba(0, 21, 64, 0.05);
        .screen {
            overflow: hidden;
            width: calc(100% - 38px * 2);
            height: calc(100% - 8px * 2);
            position: relative;
            top: 8px;
            margin: auto;
            border: 2px solid #eff1f5;
            border-radius: 5px;
            img {
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>